'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgElementStatusCtrl', sgElementStatusCtrl);

  sgElementStatusCtrl.$inject = ['Constants', 'Labels'];

  function sgElementStatusCtrl (Constants, Labels) {
    const vm = this;

    vm.$onChanges = () => {
      if (vm.element && vm.element.status) {
        Constants.getConstants().then(() => {
          vm.elementStatus = Constants.getList('STATUS_TYPES').find((status) => status._id === vm.element.status);
          if (vm.elementStatus && !vm.element.isTechnicalType) {
            nonTechnicalDisplayName();
          } else if (vm.elementStatus) {
            technicalDisplayName();
          }
        });
      }
    };

    function nonTechnicalDisplayName () {
      if (vm.element.isCustom && !vm.element.isTechnicalType) {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('projectdefinedvalue');
      } else if (vm.element.valuesChanged && !vm.element.isTechnicalType) {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('adjustedtotemplatevalue');
      } else {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('equaltotemplatevalue');
      }
    }

    function technicalDisplayName () {
      const templateValue = vm.element.templateValues.find((val) => val.quality === vm.element.quality);

      if (vm.element.basicAreaValue && vm.element.value !== vm.element.basicAreaValue) {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('adjustedtoareatemplatevalue');
      } else if (vm.element.basicAreaValue && vm.element.value !== vm.element.basicAreaValue) {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('equaltoareatemplatevalue');
      } else if (!templateValue || templateValue.value !== vm.element.value) {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('adjustedtotechdbvalue');
      } else {
        vm.statusName = vm.elementStatus.displayName + ': ' + Labels.getLabel('equaltotechdbvalue');
      }
    }
  }
})();
